export default [
  {
    title: "Merchant Report",
    customIcon: "ReportSVG",
    children: [
      {
        title: "Merchant Report List",
        route: "custom-module",
        path: "/custom-module/merchantreport",
      },
    ],
  },
];
